import React from 'react';
import { CheckIcon, WineIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { assurances, checkoutUrl, productBrand, productEdition } from '../data/offer';
export function FinalCta() {
  return <section className="border-t border-accent/20 bg-surface/40 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-58" data-mp="19g0d3ipnhwkf">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-59" data-mp="15ckkcxgpcgd0">
        <h2 id="final-title" className="text-balance text-3xl font-extrabold uppercase tracking-tight text-foreground sm:text-4xl" data-id="element-60" data-mp="1jcvc02pu5yz8">
          <span className="inline-flex items-center gap-2" data-id="element-61" data-mp="1ed8xzr26oepd">
            <WineIcon className="h-8 w-8 shrink-0 text-accent" aria-hidden="true" data-id="element-62" data-mp="1t2on72m2gc2y" /> {productBrand}
          </span>
          <span className="mt-2 block text-xl font-extrabold uppercase tracking-[.16em] text-primary sm:text-2xl" data-id="element-63" data-mp="1o3brdsd7vuo8">
            {productEdition}
          </span>
        </h2>
        <p className="mx-auto mt-4 max-w-xl text-lg leading-relaxed text-muted" data-id="element-64" data-mp="1x4jmy2ocmhem">
          Creata per aspiranti sommelier, appassionati e professionisti del vino.
        </p>

        <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" arrow className="mt-8 w-full sm:w-auto" data-id="element-65" data-mp="n7fh7tovjafo">
          Ottieni ora l&apos;Edizione Professionale
        </Button>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-muted" data-id="element-66" data-mp="x27esxighxag">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-67" data-mp="164gmlfmcbck5">
              <CheckIcon className="h-4 w-4 text-accent" aria-hidden="true" data-id="element-68" data-mp="1646wzt57j7ez" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}